export function Conceito() {
  return (
    <section id="conceito" className="py-32 px-8 lg:px-20 bg-dark">
      <div className="max-w-6xl mx-auto">
        <div className="relative bg-gradient-to-br from-dark to-dark-light rounded-[32px] p-16 lg:p-24 overflow-hidden">
          <div className="absolute top-8 right-8 opacity-10">
            <i className="ri-ancient-gate-line text-gold text-[240px] transform rotate-12"></i>
          </div>

          <div className="relative z-10 space-y-12">
            <div className="space-y-6">
              <span className="text-gold text-xs uppercase tracking-[0.3em] font-semibold">
                Legado
              </span>
              <h2 className="font-display text-5xl lg:text-6xl font-bold leading-tight">
                <span className="text-white">Uma herança de prosperidade.</span>
                <br />
                <span className="text-gold">Uma prática de impacto.</span>
              </h2>
            </div>

            <div className="grid lg:grid-cols-5 gap-12 pt-8">
              <div className="lg:col-span-2 space-y-6">
                <p className="text-gray-400 leading-relaxed">
                  No século XIV, um líder africano redefiniu o conceito de riqueza no mundo. Sua história atravessou o tempo como símbolo de gestão, visão e prosperidade.
                </p>
              </div>

              <div className="hidden lg:block lg:col-span-1 flex items-center justify-center">
                <div className="w-0.5 h-full bg-gold/20"></div>
              </div>

              <div className="lg:col-span-2 space-y-6">
                <p className="text-white text-lg font-medium leading-relaxed">
                  A Mansa Musa JH nasce inspirada nessa ideia: prosperidade como estrutura.
                </p>
                <p className="text-white text-lg font-medium leading-relaxed">
                  Hoje, traduzimos cultura em impacto real — social, econômico e institucional.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
